// Generated by ReScript, PLEASE EDIT WITH CARE


var service_category_trucks = "trucks";

var service_category_two_wheelers = "two_wheeler";

var service_category_compact = "compact";

var service_category_pnm = "packers-movers";

var service_category_partload = "partload";

var brand_label = "porter";

var source_website_label = "website";

var recaptcha_init_delay = 500;

var form_invalid_category = "Invalid Porter Service Selected";

var form_invalid_pickup_location = "Select a valid address";

var form_invalid_dropoff_location = "Select a valid address";

var form_no_pickup_location = "Enter the pickup address";

var form_no_dropoff_location = "Enter the dropoff address";

export {
  service_category_trucks ,
  service_category_two_wheelers ,
  service_category_compact ,
  service_category_pnm ,
  service_category_partload ,
  brand_label ,
  source_website_label ,
  recaptcha_init_delay ,
  form_invalid_category ,
  form_invalid_pickup_location ,
  form_invalid_dropoff_location ,
  form_no_pickup_location ,
  form_no_dropoff_location ,
}
/* No side effect */
